import { useState,useEffect } from 'react';


export const useStyleData = (style_id,fetchData=true,defaultData={}) => {
  const [style,setStyle]=useState(fetchData ? {} : defaultData );
  const [fetchingStatus,setfetchingStatus]=useState(fetchData ? "FETCHING" :"LOADED");
  const [pictures,setPictures]=useState(defaultData?.pictures?? [] );

  useEffect(()=>{
    if(!fetchData){
      setStyle(prevStyle=>({...prevStyle,...defaultData}));
    }
  },[defaultData]);

  const updateLikeCounter=(change)=>{
    setStyle({
      ...style,
      likes:Number(style.likes)+change
    })
  }

  useEffect(()=>{
    if(fetchData){
      let picturePromise=fetch(__server__ + '/API/pub/style_pictures/'+style_id, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.json())
      .then((data)=>{
        return(data)
      });

      let stylePromise=fetch(__server__ + '/API/pub/style/'+style_id, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.json())
      .then((data)=>{
        return(data[0])
      });

      let colorwaysPromise=fetch(__server__ + '/API/pub/colorways_by_style_id/'+style_id, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.json())
      .then((data)=>{
        return(data)
      });

      let resellsPromise=fetch(__server__ + '/API/pub/resells_by_style_id/'+style_id, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.json())
      .then((data)=>{
        return(data)
      });

      Promise.all([stylePromise,picturePromise,colorwaysPromise,resellsPromise]).then(([style,pictures,colorways,resells])=>{
        setStyle({
          ...style,
          pictures:pictures,
          colorways:colorways,
          resells:resells,
        });
        setfetchingStatus("LOADED");
        }
      );
    }

    else{
      fetch(__server__ + '/API/pub/style_pictures/'+style_id, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.json())
      .then((data)=>{
        setStyle((prevStyle)=>({...prevStyle,pictures:data}))
      });

    }
  },[style_id]);

  return([style,fetchingStatus,updateLikeCounter])
};
